/**
 * Billing Page Component
 * Manages subscriptions, payments, and billing information
 */
import React from 'react';
export const BillingPage = ({ user, dashboardService }) => {
    return (<div className="animate-fade-in">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Billing & Subscriptions
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Manage your subscription, payments, and billing information
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl p-8 text-center">
        <div className="text-6xl mb-4">💳</div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
          Billing Management
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Comprehensive billing and subscription management interface
        </p>
        <div className="text-sm text-gray-500 dark:text-gray-500">
          Features: Subscription plans, payment methods, invoices, usage analytics
        </div>
      </div>
    </div>);
};
//# sourceMappingURL=BillingPage.js.map